import { useEffect, useState } from 'react';
import { 
  FGButton, 
  FGInlineAlert, 
  FGInput, 
  FGInputField, 
  FGTypography,
 } from '@fg/design-system';
import { verifyEmail } from '../services/Login';
import { getBannerMessage, MessageType } from '../services/bannerMessageHelper';
import { HeaderFooter } from './HeaderFooter';

type Props = {
  customProps: {
    appCode: string;
    errorMessageCode: string;
    logoType: string;
    csrfToken: string;
    stateOauth: string;
    callback: string;
  };
};
export const EmailVerification = ({ customProps }: Props) => {
  const { appCode, logoType, csrfToken, errorMessageCode, stateOauth, callback } = customProps;
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const copyrightText = "Copyright © 2025 Fitch Ratings, Inc., Fitch Solutions, Inc., and their subsidiaries.";
  let sruErrorMessage = getBannerMessage(errorMessageCode, MessageType.SruError);

  useEffect(() => {
    setErrorMessage(sruErrorMessage);
  }, [sruErrorMessage]);

  const handleChange = (e) => {
    let email = e.target.value;
    let isValid = validateEmail(email);
    setEmail(email);
    setIsValidEmail(isValid);
    if (isValid) {
      setErrorMessage('');
    }
  };

  const handleBlur = () => {
    const errorMessage = isValidEmail ? '' : 'Please enter a valid email address.';
    setErrorMessage(errorMessage);
  };

  function validateEmail(email) {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  const handleClick = () => {
    const data = {
      email: email,
      appCode: appCode,
      state: stateOauth,
      callback: callback,
    };
    verifyEmail(data, csrfToken)
      .then((response) => {
        if (response.redirectUrl) {
          sessionStorage.setItem('userEmail', response.userEmail);
          window.location.href = response.redirectUrl;
        }
        if (response.error || response.message) {
          setErrorMessage(response.message);
        }
      })
      .catch((error: any) => {
        setErrorMessage(error);
      });
  };
  return (
    <>
      <HeaderFooter appCode={appCode} logoType={logoType} copyrightText={copyrightText}>
        <div className="fg-pd--5 fg-fxd--c tab-panel-content">
          <div className="fg-email-verification-error__banner-wrapper">
            {errorMessage && (
              <div className="fg-ta--c fg-mg--t3">
                <FGInlineAlert type="error">{errorMessage}</FGInlineAlert>
              </div>
            )}
          </div>
          <br></br>
          <FGTypography color="strong" tag="h3" style="headline3" alignment="center">
            Login or create your free account
          </FGTypography>
          <FGTypography className="fg-mg--t4" color="standard" tag="p" style="body3-short" alignment="center">
            Enter your email address to continue.
          </FGTypography>
          <div className="fg-email-verification__input">
            <FGInputField id="email-field" label="Email">
              <FGInput
                hasError={!!errorMessage}
                onChange={handleChange}
                onBlur={handleBlur}
                autoFocus
                size="l"
                id="email-field"
              />
            </FGInputField>
          </div>
          <div className="fg-mg--t6" style={{ display: 'inline-grid' }}>
            <FGButton disabled={!validateEmail(email) || !!errorMessage} size="l" onClick={handleClick}>
              Continue
            </FGButton>
          </div>
          <FGTypography className="fg-mg--t10" color="weak" tag="p" style="body3-short" alignment="center">
            By continuing, you agree to our Terms of Use, Privacy Policy, Cookie Policy, and Events Policy.
          </FGTypography>
        </div>
      </HeaderFooter>
    </>
  );
};
